export default __webpack_public_path__ + "images/WSG.e3719a2.png";